import React, { useCallback, useEffect, useState } from "react";
import { TitleTag } from "@/components/shared/item";
import styled from "@emotion/styled";
import {
  CommonContainer,
  CommonPageContainer,
} from "@/components/ui/container";
import { CommonTitleTwo } from "@/components/ui/fonts/Fonts";
import { color } from "@/theme";
import { useLocation } from "react-router-dom";
import { ContestFormModal } from "@/components/ui/modal";
import { PrimaryButton } from "@/components/ui/buttons";
import { isContestActive, isContestEnd } from "@/utils/Functions";
import { ContestResult } from "..";

const PageTitle = styled(CommonTitleTwo)(() => ({
  margin: "2rem 0",
  textAlign: "center",
}));

const ButtonWrapper = styled.div(() => ({
  width: "100%",
  marginTop: "8rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const Contest = () => {
  const [isWithinRange, setIsWithinRange] = useState(false);

  const show = localStorage.getItem("test") !== null || isWithinRange;

  const { search } = useLocation();

  const params = new URLSearchParams(search);

  const apply = params.get("apply");

  const [modalOpen, setModalOpen] = useState(false);

  const onClickSubmit = useCallback(() => {
    setModalOpen(true);
  }, []);

  const onCancel = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (apply && show) {
      setModalOpen(true);
    }
  }, [apply, show]);

  // 초 단위로 시간 체크
  useEffect(() => {
    if (!isContestEnd()) {
      const timer = setInterval(() => {
        setIsWithinRange(isContestActive());
      }, 1000);

      return () => clearInterval(timer);
    }
  }, []);

  return (
    <CommonPageContainer>
      <CommonContainer>
        <ContestFormModal modalOpen={modalOpen} onCancel={onCancel} />

        <TitleTag title="97초 공모전" bgColor={color.primary02} />

        <PageTitle>
          <p>제 1회 세이브더얼스 환경소재 숏폼 공모전</p>

          <p>97초 안에 지구를 지켜줘!</p>
        </PageTitle>

        <ContestResult />

        {/* TODO: remove */}
        {show && (
          <ButtonWrapper>
            <PrimaryButton bgColor={color.primary02} clickEvent={onClickSubmit}>
              지원 접수
            </PrimaryButton>
          </ButtonWrapper>
        )}
      </CommonContainer>
    </CommonPageContainer>
  );
};

export default Contest;
